<template>
    <div id="contenedor">
    <v-layout row wrap>
        <v-flex xs12 sm12 md12>
        <v-card class="table" elevation="4" >
            <!-- header control interno  -->
            <v-toolbar flat elevation="4" color="grey lighten-3" class="mb-5">
            <v-card class="icon">
                <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-application</v-icon
                >
            </v-card>
            <div
                class="usuario text-uppercase ml-5 font-weight-bold blue-grey--text text--darken-3"
            >
                FINALIZAR COMPRAS
            </div>
            <v-spacer></v-spacer>
            <!-- Dialog observaciones -->
            <v-dialog
                v-model="dialogProveedor1"
                persistent
                :overlay="false"
                width="90%"
            >
                <v-card>
                <v-card-title class="nav">
                    <span class="headline" style="color: white"
                    ><v-icon color="white">mdi-clipboard-edit-outline</v-icon>
                    Proceso Compra Proveedor 1
                    </span>
                </v-card-title>
                <!-- componente del modal para agregar y actualizar -->

                <div
                    style="
                    width: 95%;
                    margin: 3rem 0rem 0rem 2rem;
                    border: solid 2px black;
                    "
                    
                >
                    <div style="border: solid 1px black;" class="pa-3"  >
                    <v-layout wrap >
                        <v-flex xs1 class="ml-2">
                        <span><strong>Fecha:</strong></span>
                        </v-flex>
                        <v-flex xs4>{{editedItem.fechaActual}}</v-flex>
                        <v-flex xs1>
                        <span><strong>Solicitante:</strong></span>
                        </v-flex>
                        <v-flex xs4> {{editedItem.nombreArea}} </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs1 class="ml-2">
                        <span><strong>Proveedor:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogProveedor1==true"> {{editedItem.proveedor1.nombreEmpresa}} </v-flex>
                        <v-flex xs1>
                        <span><strong>Nit:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogProveedor1==true">{{editedItem.proveedor1.nit}}</v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs1 class="ml-2">
                        <span><strong>Asunto:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogProveedor1==true">{{editedItem.infoProceso[0].asunto}}</v-flex>
                        <v-flex xs1>
                        <span><strong>Télefono:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogProveedor1==true"> {{editedItem.proveedor1.celular}} - {{editedItem.proveedor1.telefono}}  </v-flex>
                    </v-layout>
                    </div>

                    <v-layout wrap style="width: 100%;">
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> ITEM </strong></v-flex>
                    <v-flex xs4 style="border: solid 1px black;" class="displayCenter fondo"><strong> DESCRIPCION </strong></v-flex>
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> CANT. </strong></v-flex>
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> VR.UNIT </strong></v-flex>
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> VR.TOTAL </strong></v-flex>
                    </v-layout>
                    <v-layout wrap v-for="(item, index) in editedItem.compraProveedor1" :key="index">
                        <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayCenter"> {{item.id}} </v-flex>
                        <v-flex v-if="item.id!=null" xs4 style="border: solid 1px black;"> {{item.concepto}} </v-flex>
                        <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayCenter"> {{item.cantidad}} </v-flex>
                        <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayEnd"> {{item.subtotal| currency}} </v-flex>
                        <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayEnd" > {{item.valor| currency}} </v-flex>
                        
                    
                    
                    </v-layout>
                    <v-layout wrap>
                    <v-flex xs8 style="border: solid 1px black;"> 
                        ARGUMENTO PARA LA COMPRA: 
                    </v-flex>
                    <v-flex xs2 sm2 md2>
                        <v-layout wrap>
                        <v-flex xs12 sm12 md12 style="border: solid 1px black;">
                            <label for="" class="displayEnd" ><strong>SUBTOTAL</strong></label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex xs12 sm12 md12 style="border: solid 1px black;">
                            <label for="" class="displayEnd"><strong> IVA</strong></label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex xs12 sm12 md12 style="border: solid 1px black;">
                            <label for="" class="displayEnd"><strong> TOTAL</strong></label>
                        </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs2 sm2 md2>
                        <v-layout wrap>
                        <v-flex
                            xs12
                            sm12
                            md12
                            
                            style="border: solid 1px black;"
                            v-if="dialogProveedor1==true"
                        >
                            <label for="" class="displayEnd" >{{editedItem.compraProveedor1.at(-1).subTotal| currency}}</label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex
                            xs12
                            sm12
                            md12
                            v-if="dialogProveedor1==true"
                            style="border: solid 1px black;"
                        >
                            <label for="" class="displayEnd">{{editedItem.compraProveedor1.at(-1).iva| currency}}</label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex
                            xs12
                            sm12
                            md12
                            v-if="dialogProveedor1==true"
                            style="border: solid 1px black;"
                        >
                            <label for="" class="displayEnd">{{editedItem.compraProveedor1.at(-1).total| currency}}</label>
                        </v-flex>
                        </v-layout>
                    </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs4>
                            <v-flex xs12 style="border: solid 1px black;" class="displayStart">
                                <span class="mr-4">Forma de pago:</span>
                                <span v-if="dialogProveedor1==true">{{editedItem.proveedor1.formaPago}}</span>
                            </v-flex>
                        </v-flex>
                        <v-flex xs4>
                            <v-flex xs12 style="border: solid 1px black;" class="displayStart"> 
                            <span class="mr-4">Anticipo:</span>
                            <span></span>
                            </v-flex>
                        </v-flex>
                        <v-flex xs4>
                            <v-flex xs12 style="border: solid 1px black;" class="displayStart"> 
                                <span class="mr-4">
                                    Tiempo de entrega:
                                </span>
                                <span>
                                    
                                </span>
                            </v-flex>
                        </v-flex>
                    
                    </v-layout>
                    <v-layout wrap class="mt-5 ml-2 pa-2" >
                    <v-flex xs5 sm5 md5>
                        <v-text-field
                        disabled
                        label="Mayra Londoño"
                        class="mr-4"
                        ></v-text-field>
                        <label for="">ELABORADO POR</label>
                        <br>
                            Creado:
                            <label for="">{{editedItem.fechaProveedores}}</label>
                    </v-flex>
                    <v-flex xs6 class="d-flex" v-for="(item, index) in editedItem.aprobacion" :key="index">
                        <v-layout wrap v-if="item.rol == 'DIRECTOR AREA'">
                        <v-flex xs12 sm12 md12>
                            <v-text-field disabled class="mr-4" v-model="item.firma"></v-text-field>
                            <label for="" >APROBACION DIRECTOR DE ÁREA</label>
                            <br>
                                Aprobado:
                                <label for="">{{item.fechaAprobacion}}</label>
                        </v-flex>
                        
                        </v-layout>
                    </v-flex>
                    <!-- {{editedItem.aprobacion}} -->
                    </v-layout>
                </div>

                <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn elevation="2" color="#f7e506" @click="close"
                    >Cerrar</v-btn
                    >
                    <v-btn elevation="2" color="#f7e506" @click="observaciones(editedItem)">
                        Realizar Compra
                    </v-btn>
                </v-card-actions>
                <!-- <pre>{{editedItem}}</pre>  -->
                <!-- <pre v-if="dialogProveedor1==true">{{editedItem.compraProveedor1.at(-1)}}</pre> -->
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="dialogProveedor2"
                persistent
                :overlay="false"
                width="90%"
            >
                <v-card>
                <v-card-title class="nav">
                    <span class="headline" style="color: white"
                    ><v-icon color="white">mdi-clipboard-edit-outline</v-icon>
                    Proceso Compra Proveedor 2
                    </span>
                </v-card-title>
                <!-- componente del modal para agregar y actualizar -->

                <div
                    style="
                    width: 95%;
                    margin: 3rem 0rem 0rem 2rem;
                    border: solid 2px black;
                    "
                    
                >
                    <div style="border: solid 1px black;" class="pa-3"  >
                    <v-layout wrap >
                        <v-flex xs1 class="ml-2">
                        <span><strong>Fecha:</strong></span>
                        </v-flex>
                        <v-flex xs4></v-flex>
                        <v-flex xs1>
                        <span><strong>Solicitante:</strong></span>
                        </v-flex>
                        <v-flex xs4> {{editedItem.nombreArea}} </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs1 class="ml-2">
                        <span><strong>Proveedor:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogProveedor2==true"> {{editedItem.proveedor2.nombreEmpresa}} </v-flex>
                        <v-flex xs1>
                        <span><strong>Nit:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogProveedor2==true">{{editedItem.proveedor2.nit}}</v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs1 class="ml-2">
                        <span><strong>Asunto:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogProveedor2==true">{{editedItem.infoProceso[0].asunto}}</v-flex>
                        <v-flex xs1>
                        <span><strong>Télefono:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogProveedor2==true"> {{editedItem.proveedor2.celular}} - {{editedItem.proveedor2.telefono}}  </v-flex>
                    </v-layout>
                    </div>

                    <v-layout wrap style="width: 100%;">
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> ITEM </strong></v-flex>
                    <v-flex xs4 style="border: solid 1px black;" class="displayCenter fondo"><strong> DESCRIPCION </strong></v-flex>
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> CANT. </strong></v-flex>
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> VR.UNIT </strong></v-flex>
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> VR.TOTAL </strong></v-flex>
                    </v-layout>
                    <v-layout wrap v-for="(item, index) in editedItem.compraProveedor2" :key="index">
                    
                        <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayCenter"> {{item.id}} </v-flex>
                        <v-flex v-if="item.id!=null" xs4 style="border: solid 1px black;"> {{item.concepto}} </v-flex>
                        <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayCenter"> {{item.cantidad}} </v-flex>
                        <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayEnd"> {{item.subtotal| currency}} </v-flex>
                        <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayEnd" > {{item.valor| currency}} </v-flex>
                    
                    </v-layout>
                    <v-layout wrap>
                    <v-flex xs8 style="border: solid 1px black;"> 
                        ARGUMENTO PARA LA COMPRA: 
                    </v-flex>
                    <v-flex xs2 sm2 md2>
                        <v-layout wrap>
                        <v-flex xs12 sm12 md12  style="border: solid 1px black;">
                            <label for="" class="displayEnd" ><strong>SUBTOTAL</strong></label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex xs12 sm12 md12 style="border: solid 1px black;">
                            <label for="" class="displayEnd"><strong> IVA</strong></label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex xs12 sm12 md12 style="border: solid 1px black;">
                            <label for="" class="displayEnd"><strong> TOTAL</strong></label>
                        </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs2 sm2 md2>
                        <v-layout wrap>
                        <v-flex
                            xs12
                            sm12
                            md12
                            v-if="dialogProveedor2==true"
                            style="border: solid 1px black;"
                        >
                            <label for="" class="displayEnd">{{editedItem.compraProveedor2.at(-1).subTotal| currency}}</label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex
                            xs12
                            sm12
                            md12
                            v-if="dialogProveedor2==true"
                            style="border: solid 1px black;"
                        >
                            <label for="" class="displayEnd">{{editedItem.compraProveedor2.at(-1).iva| currency}}</label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex
                            xs12
                            sm12
                            md12
                            v-if="dialogProveedor2==true"
                            style="border: solid 1px black;"
                        >
                            <label for="" class="displayEnd">{{editedItem.compraProveedor2.at(-1).total| currency}}</label>
                        </v-flex>
                        </v-layout>
                    </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs4>
                            <v-flex xs12 style="border: solid 1px black;" class="displayStart">
                                <span class="mr-4">Forma de pago:</span>
                                <span v-if="dialogProveedor2==true">{{editedItem.proveedor2.formaPago}}</span>
                            </v-flex>
                        </v-flex>
                        <v-flex xs4>
                            <v-flex xs12 style="border: solid 1px black;" class="displayStart"> 
                            <span class="mr-4">Anticipo:</span>
                            <span></span>
                            </v-flex>
                        </v-flex>
                        <v-flex xs4>
                            <v-flex xs12 style="border: solid 1px black;" class="displayStart"> 
                                <span class="mr-4">
                                    Tiempo de entrega:
                                </span>
                                <span>
                                    
                                </span>
                            </v-flex>
                        </v-flex>
                    
                    </v-layout>
                    <v-layout wrap class="mt-5 ml-2 pa-2" >
                    <v-flex xs5 sm5 md5>
                        <v-text-field
                        disabled
                        label="Mayra Londoño"
                        class="mr-4"
                        ></v-text-field>
                        <label for="">ELABORADO POR</label>
                    </v-flex>
                    <v-flex xs6 class="d-flex" v-for="(item, index) in editedItem.aprobacion" :key="index">
                        <v-layout wrap v-if="item.rol == 'DIRECTOR AREA'">
                        <v-flex xs12 sm12 md12>
                            <v-text-field disabled class="mr-4" v-model="item.firma"></v-text-field>
                            <label for="" >APROBACION DIRECTOR DE ÁREA</label>
                        </v-flex>
                        
                        </v-layout>
                    </v-flex>
                    </v-layout>
                </div>

                <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn elevation="2" color="#f7e506" @click="close"
                    >Cerrar</v-btn
                    >
                    <v-btn elevation="2" color="#f7e506" @click="observaciones1(editedItem)">
                        Realizar Compra
                    </v-btn>
                </v-card-actions>
                <!-- <pre>{{editedItem}}</pre>  -->
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="dialogProveedor3"
                persistent
                :overlay="false"
                width="90%"
            >
                <v-card>
                <v-card-title class="nav">
                    <span class="headline" style="color: white"
                    ><v-icon color="white">mdi-clipboard-edit-outline</v-icon>
                    Proceso Compra Proveedor 3
                    </span>
                </v-card-title>
                <!-- componente del modal para agregar y actualizar -->

                <div
                    style="
                    width: 95%;
                    margin: 3rem 0rem 0rem 2rem;
                    border: solid 2px black;
                    "
                    
                >
                    <div style="border: solid 1px black;" class="pa-3"  >
                    <v-layout wrap >
                        <v-flex xs1 class="ml-2">
                        <span><strong>Fecha:</strong></span>
                        </v-flex>
                        <v-flex xs4></v-flex>
                        <v-flex xs1>
                        <span><strong>Solicitante:</strong></span>
                        </v-flex>
                        <v-flex xs4> {{editedItem.nombreArea}} </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs1 class="ml-2">
                        <span><strong>Proveedor:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogProveedor3==true"> {{editedItem.proveedor3.nombreEmpresa}} </v-flex>
                        <v-flex xs1>
                        <span><strong>Nit:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogProveedor3==true">{{editedItem.proveedor3.nit}}</v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs1 class="ml-2">
                        <span><strong>Asunto:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogProveedor3==true">{{editedItem.infoProceso[0].asunto}} </v-flex>
                        <v-flex xs1>
                        <span><strong>Télefono:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogProveedor3==true"> {{editedItem.proveedor3.celular}} - {{editedItem.proveedor3.telefono}}  </v-flex>
                    </v-layout>
                    </div>

                    <v-layout wrap style="width: 100%;">
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> ITEM </strong></v-flex>
                    <v-flex xs4 style="border: solid 1px black;" class="displayCenter fondo"><strong> DESCRIPCION </strong></v-flex>
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> CANT. </strong></v-flex>
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> VR.UNIT </strong></v-flex>
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> VR.TOTAL </strong></v-flex>
                    </v-layout>
                    <v-layout wrap v-for="(item, index) in editedItem.compraProveedor3" :key="index">
                    <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayCenter"> {{item.id}} </v-flex>
                    <v-flex v-if="item.id!=null" xs4 style="border: solid 1px black;"> {{item.concepto}} </v-flex>
                    <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayCenter"> {{item.cantidad}} </v-flex>
                    <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayEnd"> {{item.subtotal| currency}} </v-flex>
                    <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayEnd" > {{item.valor| currency}} </v-flex>
                    </v-layout>
                    <v-layout wrap>
                    <v-flex xs8 style="border: solid 1px black;"> 
                        ARGUMENTO PARA LA COMPRA: 
                    </v-flex>
                    <v-flex xs2 sm2 md2>
                        <v-layout wrap>
                        <v-flex xs12 sm12 md12 style="border: solid 1px black;">
                            <label for="" class="displayEnd" ><strong>SUBTOTAL</strong></label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex xs12 sm12 md12 style="border: solid 1px black;">
                            <label for="" class="displayEnd"><strong> IVA</strong></label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex xs12 sm12 md12 style="border: solid 1px black;">
                            <label for="" class="displayEnd"><strong> TOTAL</strong></label>
                        </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs2 sm2 md2>
                        <v-layout wrap>
                        <v-flex
                            xs12
                            sm12
                            md12
                            v-if="dialogProveedor3==true"
                            style="border: solid 1px black;"
                        >
                            <label for="" class="displayEnd">{{editedItem.compraProveedor3.at(-1).subTotal| currency}}</label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex
                            xs12
                            sm12
                            md12
                            v-if="dialogProveedor3==true"
                            style="border: solid 1px black;"
                        >
                            <label for="" class="displayEnd">{{editedItem.compraProveedor3.at(-1).iva| currency}}</label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex
                            xs12
                            sm12
                            md12
                            v-if="dialogProveedor3==true"
                            style="border: solid 1px black;"
                        >
                            <label for="" class="displayEnd">{{editedItem.compraProveedor3.at(-1).total| currency}}</label>
                        </v-flex>
                        </v-layout>
                    </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs4>
                            <v-flex xs12 style="border: solid 1px black;" class="displayStart">
                                <span class="mr-4">Forma de pago:</span>
                                <span v-if="dialogProveedor3==true">{{editedItem.proveedor3.formaPago}}</span>
                            </v-flex>
                        </v-flex>
                        <v-flex xs4>
                            <v-flex xs12 style="border: solid 1px black;" class="displayStart"> 
                            <span class="mr-4">Anticipo:</span>
                            <span></span>
                            </v-flex>
                        </v-flex>
                        <v-flex xs4>
                            <v-flex xs12 style="border: solid 1px black;" class="displayStart"> 
                                <span class="mr-4">
                                    Tiempo de entrega:
                                </span>
                                <span>
                                    
                                </span>
                            </v-flex>
                        </v-flex>
                    
                    </v-layout>
                    <v-layout wrap class="mt-5 ml-2 pa-2" >
                    <v-flex xs5 sm5 md5>
                        <v-text-field
                        disabled
                        label="Mayra Londoño"
                        class="mr-4"
                        ></v-text-field>
                        <label for="">ELABORADO POR</label>
                    </v-flex>
                    <v-flex xs6 class="d-flex" v-for="(item, index) in editedItem.aprobacion" :key="index">
                        <v-layout wrap v-if="item.rol == 'DIRECTOR AREA'">
                        <v-flex xs12 sm12 md12>
                            <v-text-field disabled class="mr-4" v-model="item.firma"></v-text-field>
                            <label for="" >APROBACION DIRECTOR DE ÁREA</label>
                        </v-flex>
                        
                        </v-layout>
                    </v-flex>
                    <!-- {{editedItem.aprobacion}} -->
                    </v-layout>
                </div>

                <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn elevation="2" color="#f7e506" @click="close">
                        Cerrar
                    </v-btn>
                    <v-btn elevation="2" color="#f7e506" @click="observaciones2(editedItem)">
                        Realizar Compra
                    </v-btn>
                </v-card-actions>
                <!-- <pre>{{editedItem}}</pre>  -->
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="dialog_observaciones"
                spersistent :overlay="false"
                width="30%">
                <v-card>
                    <v-card-text>
                    <v-flex xs12 style="display: flex;
                                        justify-content: center;">
                        <v-icon style="font-size:5rem; 
                                        margin-bottom:3rem; 
                                        margin-top:2rem;"
                                        color="#f8bb86">
                                        mdi-alert-circle
                        </v-icon>
                    </v-flex>
                        
                        <v-layout wrap>
                            <v-flex xs12 sm12 md12>
                                <v-textarea
                                    v-model="observaciones_text"
                                    label="Argumento para la compra"
                                    maxlength="80"
                                ></v-textarea>
                            </v-flex> 
                        </v-layout>
                    </v-card-text>
                    
                    <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn color="#f7e506"  @click="close">Cancelar</v-btn>
                        <v-btn
                        color="#f7e506"
                        @click="realizarCompra1(editedItem)"
                        :disabled="!observaciones_text"
                        >Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="dialog_observaciones1"
                spersistent :overlay="false"
                width="30%">
            >
                <v-card>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex xs12 style="display: flex;
                                        justify-content: center;">
                                <v-icon style="font-size:5rem; 
                                        margin-bottom:3rem; 
                                        margin-top:2rem;"
                                        color="#f8bb86">
                                        mdi-alert-circle
                                </v-icon>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-textarea
                                    v-model="observaciones_text"
                                    label="Argumento para la compra"
                                    maxlength="80"
                                ></v-textarea>
                            </v-flex> 
                        </v-layout>
                    </v-card-text>
                    
                    <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn color="#f7e506"  @click="close">Cancelar</v-btn>
                        <v-btn
                        color="#f7e506"
                        @click="realizarCompra2(editedItem)"
                        :disabled="!observaciones_text"
                        >Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="dialog_observaciones2"
                spersistent :overlay="false"
                width="30%"
            >
                <v-card>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex xs12 style="display: flex;
                                        justify-content: center;">
                                <v-icon style="font-size:5rem; 
                                        margin-bottom:3rem; 
                                        margin-top:2rem;"
                                        color="#F8BB86">
                                        mdi-alert-circle
                                </v-icon>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-textarea
                                    v-model="observaciones_text"
                                    label="Argumento para la compra"
                                    maxlength="80"
                                ></v-textarea>
                            </v-flex> 
                        </v-layout>
                    </v-card-text>
                    
                    <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn color="#f7e506"  @click="close">Cancelar</v-btn>
                        <v-btn
                        color="#f7e506"
                        @click="realizarCompra3(editedItem)"
                        :disabled="!observaciones_text"
                        >Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            </v-toolbar>
            <br />
            <v-col cols="12" class="ma-0">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar Proceso"
                class="text-field"
                single-line
                color="#111c3d"
            ></v-text-field>
            </v-col>
            <br />
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <v-col cols="12" class="ma-0">
            <v-data-table
                :headers="headers"
                :items="procesos"
                :search="search"
                style="border: 2px solid #111c3d"
                class="elevation-3"
            >
                <template v-slot:no-data>
                <v-alert
                    :value="true"
                    color="#F44336"
                    icon="mdi-alert"
                    outlined
                    type="warning"
                    prominent
                    border="left"
                >
                    <strong>No</strong> se encontro su busqueda
                </v-alert>
                </template>
                <!--acciones de los datos obtenidos del arreglo-->
                <template v-slot:[`item.pdfGeneral`]="{ item }">
                    <template>
                        <div v-if="item.compraProveedor1[0].estadoCompra==1">
                            
                        </div>
                        <div v-else>
                            <div v-if="item.compraProveedor1.length > 0">
                                <v-icon class="mr-2" @click="modalPdf(item)" color="red">
                                    mdi-account
                                </v-icon>
                            </div>
                        </div>
                    </template>
                    <template>
                        <div v-if="item.compraProveedor2.length > 0">
                            <div v-if="item.compraProveedor2[0].estadoCompra==1">
                            
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="item.compraProveedor3.length > 0">
                                <v-icon class="mr-2" @click="modalPdf1(item)" color="red">
                                    mdi-account-multiple
                                </v-icon>
                            </div>
                        </div>
                        
                        
                    </template>
                    <template>
                        <div v-if="item.compraProveedor3.length > 0">
                            <div v-if="item.compraProveedor3[0].estadoCompra==1">
                            
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="item.compraProveedor3.length > 0">
                                <v-icon class="mr-2" @click="modalPdf2(item)" color="red">
                                    mdi-account-group
                                </v-icon>
                            </div>
                        </div>
                    </template>
                </template>
            </v-data-table>
            </v-col>

            <!-- alertas de las acciones que se hacen -->
            <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
            color="#601ae4"
            style="color: white"
            >
            {{ text }}
            <v-btn color="#601ae4" depressed @click="snackbar = false"
                >Cerrar</v-btn
            >
            </v-snackbar>
        </v-card>
        </v-flex>
    </v-layout>
    </div>
</template>

<script>
    import axios from "axios"; 
    import env from "../env";
    import Vue from "vue";
    import swal from "sweetalert";
    import Swal from 'sweetalert2'
    import VueCurrencyFilter from "vue-currency-filter";
    Vue.use(VueCurrencyFilter, {
        symbol: "$",
        thousandsSeparator: ".",
        fractionCount: 2,
        fractionSeparator: ",",
        symbolPosition: "front",
        symbolSpacing: true,
    });

    export default {
        data() {
            return {
                show: false,
                snackbar: false,
                y: "top",
                x: null,
                mode: "",
                timeout: 6000,
                text: "",
                search: "",
                procesos: [],
                infoProcesos: [],
                valoresProveedores: [],
                dialog: false,
                dialogProveedor1: false,
                dialogProveedor2: false,
                dialogProveedor3: false,
                dialogRechazar: false,
                compraProveedor:[],
                observaciones_text: "",
                dialog_observaciones:false,
                dialog_observaciones1:false,
                dialog_observaciones2:false,
                headers: [
                {
                    text: "ID PROCESO",
                    value: "idProceso",
                    align: "center",
                    class: "column",
                },
                {
                    text: "AREA",
                    value: "nombreArea",
                    align: "center",
                    class: "column",
                },
                {
                    text: "DIRECTOR",
                    value: "nombre",
                    align: "center",
                    class: "column",
                },
                {
                    text: "INFORME",
                    value: "pdfGeneral",
                    align: "center",
                    class: "column",
                },
                ],
                defaultItem: {
                    id: "",
                    concepto: "",
                    cantidad: "",
                    especificacion: "",
                    observaciones: "",
                    aprobacion: "",
                },
                editedIndex: -1,
                editedItem: {
                    id: "",
                    concepto: "",
                    cantidad: "",
                    especificacion: "",
                    observaciones: "",
                    aprobacion: "",
                },
            };
            },
            watch: {
                dialog(val) {
                    val || this.close();
                },
            },
            mounted() {
                this.obtenerApps();
            },
            methods: {
            obtenerApps() {
                axios
                .get(`${env.endpoint}user/procesosComprasFinalizados`)
                .then((res) => {
                    this.procesos = res.data;
                    for (let index = 0; index <= this.procesos.length; index++) {
                        this.infoProcesos = this.procesos[index].infoProceso;
                    }
                    for (let index = 0; index < this.infoProcesos.length; index++) {
                        this.infoProcesos[index].append(
                            "idProceso",
                        this.procesos[index].idProceso
                    );
                    }
                });
            },
            
            close() {
                this.dialogProveedor1 = false;
                this.dialogProveedor2 = false;
                this.dialogProveedor3 = false;
                this.dialog_observaciones = false;
                this.dialog_observaciones1 = false;
                this.dialog_observaciones2 = false;
                setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                }, 300);
            },
            observaciones(item) {
                this.editedIndex = this.procesos.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog_observaciones = true;
            },
            observaciones1(item) {
                this.editedIndex = this.procesos.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog_observaciones1 = true;
            },
            observaciones2(item) {
                this.editedIndex = this.procesos.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog_observaciones2 = true;
            },
            modalPdf(item) {
                this.editedIndex = this.procesos.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.compraProveedores(item.compraProveedor1)
                this.dialogProveedor1 = true;
            },
            modalPdf1(item) {
                this.editedIndex = this.procesos.indexOf(item);
                this.editedItem = Object.assign({}, item);
                // this.compraProveedores(item.compraProveedor2)
                this.dialogProveedor2 = true;
            },
            modalPdf2(item) {
                this.editedIndex = this.procesos.indexOf(item);
                this.editedItem = Object.assign({}, item);
                // this.compraProveedores(item.compraProveedor3)
                this.dialogProveedor3 = true;
            },
            compraProveedores(item){
                // console.log(item);
                // let compra = item
                // this.compraProveedor = compra.splice(-1)
                // console.log(this.compra);
                
            },
            realizarCompra1(item){
            swal({
                title: "Se enviara los procesos.",
                text: "¿Estas seguro que deseas enviar?",
                icon: "warning",
                buttons: ["Cancelar", true],
                dangerMode: true,
            })
            .then((willDelete) => {
                if (willDelete) {
                    let infoProveedor = JSON.stringify(item.compraProveedor1)
                    
                    axios
                    .get(`${env.endpoint}user/realizarCompra?idUser=${localStorage.getItem("id")}&idProceso=${item.idProceso}&info=${infoProveedor}&proveedor=1&observaciones=${this.observaciones_text}`)
                    .then((res) => {
                        this.obtenerApps();
                        swal(
                            "Se ha enviado con exito!", {
                            icon: "success",
                        });
                        this.procesos = res.data;
                        this.obtenerApps();
                        this.close();
                    })
                    .catch((error) => {
                        this.obtenerApps();
                        this.text =
                            "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
                    })
                    .finally(() => {
                        this.close();
                        this.obtenerApps();
                    });
                } else {
                    swal("Proceso de compra se cancelo");
                    this.close();
                }
            });
            },

            realizarCompra2(item){
                swal({
                title: "Realizar Compra",
                    text: "Compra realizada satisfactoriamente",
                    icon: "success",
                    buttons: ["Cancelar", true],
                }).then((willDelete) => {
                if (willDelete) {
                    let infoProveedor = JSON.stringify(itemcompraProveedor2)
                    axios
                    .get(`${env.endpoint}user/realizarCompra?idUser=${localStorage.getItem("id")}&idProceso=${item.idProceso}&info=${infoProveedor}&proveedor=2&observaciones=${this.observaciones_text}`)
                    .then((res) => {
                        this.obtenerApps();
                        swal(
                            "Se ha enviado con exito!", {
                            icon: "success",
                        });
                        this.procesos = res.data;
                        this.obtenerApps();
                        this.close();
                    })
                    .catch((error) => {
                        this.obtenerApps();
                        this.text =
                            "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
                    })
                    .finally(() => {
                        
                        this.obtenerApps();
                        this.close();
                    });
                } else {
                    swal("Proceso de compra se cancelo");
                    this.close();
                }
            });
            },

            realizarCompra3(item){
                swal({
                    title: "Realizar Compra",
                    text: "Compra realizada satisfactoriamente",
                    icon: "success",
                    buttons: ["Cancelar", true],
                }).then((willDelete) => {
                if (willDelete) {
                    let infoProveedor = JSON.stringify(itemcompraProveedor3)
                    axios
                    .get(`${env.endpoint}user/realizarCompra?idUser=${localStorage.getItem("id")}&idProceso=${item.idProceso}&info=${infoProveedor}&proveedor=3&observaciones=${this.observaciones_text}`)
                    .then((res) => {
                        this.obtenerApps();
                        swal(
                            "Se ha enviado con exito!", {
                            icon: "success",
                        });
                        this.procesos = res.data;
                        this.obtenerApps();
                        this.close();
                    })
                    .catch((error) => {
                        this.obtenerApps();
                        this.text =
                            "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
                    })
                    .finally(() => {
                        this.close();
                        this.obtenerApps();
                    });
                } else {
                    swal("Proceso de compra se cancelo");
                    this.close();
                }
            });
            },
            },
    };
</script>

<style lang="scss" scoped>
    .fondo {
    background-color: rgb(207, 206, 206);
    }
    .displayCenter {
    display: flex;
    justify-content: center;
    align-items: center;
    word-break: break-all;
    padding: 3px 0px 3px 0px;
    }
    .displayEnd {
    display: flex;
    justify-content: end;
    align-items: end;
    word-break: break-all;
    padding: 10px;
    }
    .displayStart {
    display: flex;
    justify-content: start;
    align-items: start;
    word-break: break-all;
    padding: 10px;
    }
    .colorMin {
    background-color: #4bddfd;
    }
    
    /* Estilos para scroll horizontal en tablas */
    .v-data-table >>> .v-data-table__wrapper {
        overflow-x: scroll !important;
        overflow-y: visible !important;
        max-width: 100%;
    }
    
    .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
        height: 12px !important;
        display: block !important;
        -webkit-appearance: none;
    }
    
    .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
        background: #e5e7eb !important;
        border-radius: 6px !important;
        margin: 0 10px;
    }
    
    .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
        background: #64748b !important;
        border-radius: 6px !important;
        border: 2px solid #e5e7eb;
    }
    
    .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
        background: #475569 !important;
    }
    
    .v-data-table >>> .v-data-table__wrapper {
        scrollbar-width: thin;
        scrollbar-color: #64748b #e5e7eb;
    }
</style>
